import { ErrorLogComponent } from '@cian/error-log-component';
import React, { memo } from 'react';

import { useApplicationContext } from '../../../../../utils/applicationContext';
import { YMInitAwaitCenter } from '../YMInitAwaitCenter';

const ActionsCenters = memo(function ActionsCenters() {
  const { logger } = useApplicationContext();

  return (
    <ErrorLogComponent logger={logger} level="error">
      <YMInitAwaitCenter />
    </ErrorLogComponent>
  );
});

// eslint-disable-next-line import/no-default-export
export default ActionsCenters;
